import { render, staticRenderFns } from "./YearGoalChatContainer.vue?vue&type=template&id=270a7523&"
import script from "./YearGoalChatContainer.vue?vue&type=script&lang=js&"
export * from "./YearGoalChatContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports